import {
    FETCH_ALL_AVAILABLE_DEVICE_BACKUPS,
    FETCH_COMPATIBLE_DEVICE_BACKUPS,
    RESTORE_DEVICE_BACKUP,
    REMOVE_DEVICE_BACKUP,
    FETCH_COMPATIBLE_DEVICE_BACKUPS_SUCCESS,
    SHOULD_LAUNCH_GARMIN_EXPRESS,
    RESET_DEVICE_BACKUPS,
    RESET_DEVICE_BACKUPS_ERRORS
} from './ActionTypes.js';

/** @typedef {import('reducers/device/types/DeviceBackupDTO').DeviceBackupDTO} DeviceBackupDTO */

export function fetchAllAvailableBackups() {
    return {
        type: FETCH_ALL_AVAILABLE_DEVICE_BACKUPS
    };
}

/**
 * @param {{
 *  deviceId: number; // the device id for which to fetch compatible backups
 * }} payload
 */
export function fetchCompatibleDeviceBackups(payload) {
    return {
        type: FETCH_COMPATIBLE_DEVICE_BACKUPS,
        payload
    };
}

/**
 * @param {{
 *  compatibleDeviceBackups: DeviceBackupDTO[]
 * }} payload
 */
export const fetchCompatibleDeviceBackupsSuccess = (payload) => ({
    type: FETCH_COMPATIBLE_DEVICE_BACKUPS_SUCCESS,
    payload
});

export function restoreDeviceBackup(payload) {
    return {
        type: RESTORE_DEVICE_BACKUP,
        payload
    };
}

export function removeDeviceBackup(payload) {
    return {
        type: REMOVE_DEVICE_BACKUP,
        payload
    };
}

export function shouldLaunchGarminExpressAction(payload) {
    return {
        type: SHOULD_LAUNCH_GARMIN_EXPRESS,
        payload
    };
}

export function resetDeviceBackups() {
    return {
        type: RESET_DEVICE_BACKUPS
    };
}

export function resetDeviceBackupsErrors() {
    return {
        type: RESET_DEVICE_BACKUPS_ERRORS
    };
}
